import React from "react";
import _ from "lodash";
import AppConstants from "../../constants/AppConstants";
import PlaceholderBackground from "../utils/PlaceholderBackground.jsx";

import HTMLUtils from "../../utils/HTMLUtils";
import StyleUtils from "../../utils/StyleUtils";
import AssetUtils from "../../utils/AssetUtils.js";

const PLACEHOLDER_ICON = (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 24 24"
    enableBackground="new 0 0 24 24"
    style={{ width: "100%", height: "100%" }}
  >
    <g fill="#fff">
      <path
        d="M22.8,3H1.2C0.6,3,0,3.6,0,4.2v15.5C0,20.4,0.6,21,1.2,21h21.5c0.7,0,1.2-0.6,1.2-1.2V4.2C24,3.6,23.4,3,22.8,3z
                                                             M16.2,12.4l-7,4c-0.1,0-0.2,0.1-0.2,0.1c-0.1,0-0.2,0-0.3-0.1c-0.2-0.1-0.2-0.3-0.2-0.4l0-8c0-0.2,0.1-0.3,0.2-0.4
                                                            c0.2-0.1,0.3-0.1,0.5,0l7,4c0.2,0.1,0.3,0.3,0.3,0.4C16.5,12.2,16.4,12.3,16.2,12.4z"
      />
    </g>
  </svg>
);

const EMPTY_CONTENT = <></>;

class Video extends React.PureComponent {
  render() {
    const style = { width: "100%", height: "100%", background: "#000" };
    let content = EMPTY_CONTENT;
    const video = this?.props?.content;

    if (video) {
      const type = video.get("type", false);
      const id = video.get("id", false);
      if (id) {
        switch (type) {
          case AppConstants.VIDEO_TYPE_VIMEO:
            content = this._getVimeoFrame(video, id);
            break;
          case AppConstants.VIDEO_TYPE_YOUTUBE:
            content = this._getYoutubeFrame(video, id);
            break;
        }
      } else if (type === AppConstants.VIDEO_TYPE_ASSET && video?.get("key")) {
        content = this._getVideoAssetFrame(video, id);
      } else {
        const placeholderInstrux = <span>Add Video in the Property Panel&nbsp;&#8594;</span>;

        content = <PlaceholderBackground icon={PLACEHOLDER_ICON} instrux={placeholderInstrux} />;
      }
    }

    return <div style={style}>{content}</div>;
  }

  _getVimeoFrame = (video, id) => {
    let config = video.get("config");
    const theme = this.props.theme;

    if (config) {
      config = config.toJS();
    } else {
      config = {};
    }

    if (_.has(config, "color")) {
      config.color = StyleUtils.getColorValue(config.color, theme).replace("#", "");
    }

    if (_.has(config, "autoplay")) {
      _.unset(config, "autoplay");
    }

    let options = "?" + HTMLUtils.toQueryString(config);

    return id ? (
      <iframe
        src={AppConstants.VIDEO_PLAYER_URL_VIMEO + id + options}
        width="100%"
        height="100%"
        frameBorder="0"
        allowFullScreen
      />
    ) : null;
  };

  _getYoutubeFrame = (video, id) => {
    const config = {
      controls: video.getIn(["config", "controls"], 1),
    };

    let options = "?" + HTMLUtils.toQueryString(config);

    return id ? (
      <iframe
        type="text/html"
        src={AppConstants.VIDEO_PLAYER_URL_YOUTUBE + id + options}
        width="100%"
        height="100%"
        frameBorder="0"
        allowFullScreen
      />
    ) : null;
  };

  _getVideoAssetFrame = (video) => {
    const controls = video.getIn(["config", "controls"]) || undefined;
    const selectedVideo = video?.get("key");

    return selectedVideo ? (
      <video
        poster={AssetUtils.getV2PreviewURL(selectedVideo)}
        width="100%"
        height="100%"
        controls={controls}
        style={{ objectFit: "cover" }}
      >
        <track kind="captions" src="" label="No captions available" default />
        Your browser does not support the video tag.
      </video>
    ) : null;
  };
}

export default Video;
